<template>
  <div class="about">
    <h1>A site to better the world</h1>
  </div>
</template>
